// ============================================================================
// JARVISTRAVEL - DATE RANGE ROW
// The two-column row a from/to pair sits in, in one place.
//
// This is the third time the same bug shipped: Add a stay (JAR-2468), the
// Jarvis planner (JAR-2609), and Edit trip (JAR-2625), where Brent photographed
// the Ends field running past the right edge of his iPhone. Each screen laid
// its own pair out, so fixing one taught the others nothing.
//
// WHAT ACTUALLY GOES WRONG. iPhone Safari gives `<input type="date">` a wide
// intrinsic minimum width. A grid or flex item defaults to `min-width: auto`,
// which resolves to that minimum, so the item refuses to shrink and the second
// date overflows its column into the first. Chromium's date input is narrow
// enough that the row still fits, which is why the browser pane keeps saying
// this is fixed when it is not.
//
// `grid-cols-2` is Tailwind for `repeat(2, minmax(0, 1fr))` — the `minmax(0,…)`
// is what lets a column go narrower than its content, and is the half that the
// `gap-3` flex rows this replaces did not have. The inputs' own half,
// `min-w-0 appearance-none`, lives in `Input` so that every date field gets it
// without each screen remembering (see Input.tsx).
// ============================================================================

import type { ReactNode } from 'react';

/**
 * A from/to pair, side by side, that fits a phone.
 *
 * Takes the two fields as children rather than their props: the three callers
 * need different labels, errors, `min`, `required` and `disabled`, and a
 * component that accepted all of those would be a worse version of `Input`
 * twice over. What is shared here is the layout, which is the part that was
 * wrong.
 */
export function DateRangeFields({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`grid grid-cols-2 gap-3 ${className}`.trim()}>{children}</div>;
}
